// extracted by mini-css-extract-plugin
module.exports = {"sg_lst":"sg_lst-Y1Cll2Im","arl_rs_tit":"arl_rs_tit-1xw7PiTO","sg_lst_pic":"sg_lst_pic-1fsW_nqq","li_title":"li_title-cfD9ZpXp","sg_lst_txt":"sg_lst_txt-3WPl8cqL"};